export default __webpack_public_path__ + "static/media/cpp-icon.3d047c46.svg";